<template>
    <div
        id="app"
        v-if="hasSecurityLoaded"
    >
        <header-wrapper />
        <navbar-component />
        <router-view />
    </div>
</template>

<script lang="ts">

import { Component, Vue } from 'vue-property-decorator';
import HeaderWrapper from '@/components/header/header.vue';
import Snackbar from '@/components/snackbar/snackbar.vue';
import Loader from '@/components/loader/loader.vue';
import NavbarComponent from '@/components/navbar/navbar.vue';
import './main.less';
import { APP_SCOPE } from '@/utils/coode-sdk-config';
import { sdk } from '@/utils/coode-sdk-config';

@Component({
    name: 'app',
    components: {
        HeaderWrapper,
        Snackbar,
        Loader,
        NavbarComponent
    },
})
export default class App extends Vue {
    private hasSecurityLoaded = false;

    private async created(): Promise<void> {
        await sdk.auth.loadAuthModule()
        await sdk.auth.attemptSsoSilent('loginRedirect');

        sdk?.backend.request.api.setBaseUrl(process.env.VUE_APP_API_BASE_URL as string);
        sdk?.backend.request.api.setTokenCallback(
            async () => sdk?.auth.getToken(APP_SCOPE)
        );

        const isSignedIn = sdk?.auth.isAuthenticated();
        if (isSignedIn) {
            const useCaseId = Number(process.env.VUE_APP_USE_CASE_ID);
            const hasPermissionsSet = await sdk?.core.userAccessManagement.setPermissions(useCaseId)

            if (hasPermissionsSet) {
                const permissions = sdk?.localStorage.getPermissionsLocalStorage();
                await this.$store.dispatch('user/setProfile', permissions);
            }

            this.hasSecurityLoaded = true;
        }
    }
}
</script>

<style lang="less">
</style>
